export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/IR-39d2ed9dd3d5ea0feb1258a0982006a6.png";